import type { FC } from 'react'

import { Input, Textarea } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'
import type { InjuryType } from '@/app/types'

import './DamageDescription.styles.scss'

const DamageDescription: FC<{ injuryType: InjuryType | string; isEditable: boolean }> = ({
  injuryType,
  isEditable,
}) => {
  if (!injuryType) return null

  return (
    <section className="damage-description">
      <h3>
        <Text id="Damage description" />
      </h3>

      <div className="damage-description__time-and-place">
        <Field name="damageLocation">
          {({ field, meta }: FieldProps) => (
            <Input
              id="damageLocation"
              label={<Text id="Where did the damage occur?" />}
              error={meta.error}
              touched={meta.touched}
              marginRight={16}
              isDisabled={!isEditable}
              {...field}
            />
          )}
        </Field>

        <Field name="injuryDate">
          {({ field, meta }: FieldProps) => (
            <Input
              id="injuryDate"
              type="datetime-local"
              label={<Text id="Time" />}
              error={meta.error}
              touched={meta.touched}
              isDisabled={!isEditable}
              {...field}
            />
          )}
        </Field>
      </div>

      <Field name="damageCause">
        {({ field, meta }: FieldProps) => (
          <Textarea
            id="damageCause"
            marginBottom={16}
            label={<Text id="Cause of the damage" />}
            error={meta.error}
            touched={meta.touched}
            isDisabled={!isEditable}
            {...field}
          />
        )}
      </Field>

      {injuryType === 'DAMAGE' && (
        <Field name="damageDescription">
          {({ field, meta }: FieldProps) => (
            <Textarea
              id="damageDescription"
              marginBottom={16}
              label={<Text id="Extent of damage" />}
              error={meta.error}
              touched={meta.touched}
              isDisabled={!isEditable}
              {...field}
            />
          )}
        </Field>
      )}
    </section>
  )
}

export default DamageDescription
